import React from "react";
import Lottie from "lottie-react";
import circleanimation from "../../../../../json/Animation/timeline.json";


const CircleAnimation = () => {

  return (
    <div className="flex items-center w-full h-full">
      <Lottie
        animationData={circleanimation}
        loop={true}
        autoplay={true}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
};

export default CircleAnimation;
